import React from 'react'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import formatCurrency from 'App/helpers/formatCurrency'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

@withGraphQL(
  gql`
    query currencyTransformFactor($inCurrencyCode: ID!, $outCurrencyCode: ID) {
      currencyTransformFactor(inCurrencyCode: $inCurrencyCode, outCurrencyCode: $outCurrencyCode) {
        factor
        outCurrency {
          code
          units
          format
          symbol
        }
      }
    }
  `,
  {
    loading: null,
    options: {
      fetchPolicy: 'cache-first'
    }
  }
)
export default class AmountInCurrency extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    currencyTransformFactor: PropTypes.object,
    code: PropTypes.bool,
    symbol: PropTypes.bool,
    amount: PropTypes.number,
    tooltip: PropTypes.string
  }

  static defaultProps = {
    symbol: true,
    code: true
  }

  render() {
    if (!this.props.currencyTransformFactor) return <span className={this.props.className}>0</span>
    return (
      <span className={this.props.className}>
        <Tooltip content={this.props.tooltip ? this.props.tooltip : undefined}>
          <span className="amount-value">
            {formatCurrency(
              this.props.amount * this.props.currencyTransformFactor.factor,
              this.props.currencyTransformFactor.outCurrency,
              {
                code: false,
                symbol: this.props.symbol
              }
            )}
          </span>
          {this.props.code ? (
            <span className="amount-code">
              {' '}
              {this.props.currencyTransformFactor.outCurrency.code}
            </span>
          ) : (
            ''
          )}
        </Tooltip>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/AmountInCurrency/index.js